<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'parallelogram', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="parallelogram-width"
			:id="`${prefix}measurements-parallelogram-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width', 'parallelogram')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}parallelogram-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'parallelogram')"
			v-model="width"
		/>

		<dimension-input
			inputRef="parallelogram-height"
			:id="`${prefix}measurements-parallelogram-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height', 'parallelogram')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}parallelogram-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'parallelogram')"
			v-model="height"
		/>
	</shape-input-fields-wrapper>
</template>
